"use strict";
import {Loader} from "@googlemaps/js-api-loader"
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import {createCustomPopupOverlayClass} from "../class/CustomPopupOverlay";

export const archiveMap = () => ({
    houses: [],
    map: null,
    markers: [],
    validCoordinates: [],
    markerElements: [],
    clusters: [],
    infoWindow: null,
    styles: JSON.parse(tailpress.mapStyle),
    listenerSet: false,
    init(items = {}) {
        this.houses = Array.from(items.length ? items : document.querySelectorAll('[data-house-json-map]')).map(element => {
            const jsonString = element.getAttribute('data-house-json-map');
            if (jsonString.length > 0) {
                try {
                    return JSON.parse(jsonString);
                } catch (error) {
                    console.error('Errore nel parsing JSON:', error, jsonString);
                    return false;
                }
            }
            return false;
        }).filter(Boolean);
        this.initMap();
        this.addHouseHoverListener();
        this.bindEvents();

    },
    bindEvents() {
        if (!this.listenerSet) {
            this.listenerSet = true;
            jQuery(window).on('append.infiniteScroll', (event, body, path, items, response) => {
                this.init(items);
            });
        }
        document.addEventListener('click', (e) => {
            const popup = document.querySelector('.info__window__container');
            const isClickInsidePopup = popup && popup.contains(e.target);
            const isClickOnMarker = e.target.closest('.custom-marker');

            if (!isClickInsidePopup && !isClickOnMarker) {
                if (this.activePopup) {
                    this.activePopup.setMap(null);
                    this.activePopup = null;
                }
            }
        });

    },

    initMap() {
        const loader = new Loader({
            apiKey: tailpress.apiKey,
            version: "weekly",
            mapIds: ["31c5ecf4e9b2eb28"]
        });
        loader.load().then(async () => {
            this.infoWindow = new google.maps.InfoWindow();

            const {Map} = await google.maps.importLibrary("maps");
            const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary("marker");

            const CustomPopupOverlay = createCustomPopupOverlayClass(google.maps.OverlayView);

            this.map = new Map(document.getElementById("archive-map"), {
                center: {lat: 41.9028, lng: 12.4964},
                zoom: 6,
                styles: this.styles,
                mapId: "31c5ecf4e9b2eb28",
                tilt: 0,
                disableDefaultUI: true,
                fullscreenControl: true,
                gestureHandling: "greedy"
            });
            this.addMarkers(AdvancedMarkerElement, PinElement, CustomPopupOverlay);
            this.centerMapOnMarkers();

        }).catch(error => console.error('Errore nel caricamento della mappa:', error));

    },
    createCustomMarkerElement(id, price) {
        const markerElement = document.createElement('div');
        markerElement.className = 'custom-marker';

        markerElement.textContent = `${price || 'NaN'} €`;
        markerElement.houseId = id;
        markerElement.elevate = () => {
            markerElement.classList.add('current-house');
            Object.assign(markerElement.style, {
                transform: 'scale(1.2)',
                backgroundColor: 'black',
                color: 'white',
                boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
            });
            this.markers[id].zIndex = 999;
        };

        markerElement.lower = () => {
            markerElement.classList.remove('current-house');
            markerElement.style.backgroundColor = 'white';
            Object.assign(markerElement.style, {
                transform: 'scale(1)',
                backgroundColor: 'white',
                color: 'black',
                boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
            });
            this.markers[id].zIndex = 1;
        };

        markerElement.addEventListener('mouseenter', markerElement.elevate);
        markerElement.addEventListener('mouseleave', markerElement.lower);


        return markerElement;
    },

    addMarkers(AdvancedMarkerElement, PinElement, CustomPopupOverlay) {
        const offset = 0.00001;
        this.houses.forEach((house, index) => {
            if (this.markerElements[house.id] === undefined && house.latitude && house.longitude) {
                //Aggiungo un offset per evitare che i marker si sovrappongano
                const lat = parseFloat(house.latitude) + (index * offset);
                const lng = parseFloat(house.longitude) + (index * offset);
                try {
                    this.validCoordinates.push({lat, lng});

                    this.markerElements[house.id] = this.createCustomMarkerElement(house.id, house.price);

                    this.markers[house.id] = new AdvancedMarkerElement({
                        position: {lat, lng},
                        map: Alpine.raw(this.map),
                        title: house.title,
                        content: this.markerElements[house.id],
                        zIndex: 1,
                    });
                    this.markers[house.id].addListener('click', () => {
                        const content = document.createElement('div');
                        content.className = 'info__window__container';
                        content.innerHTML = this.getInfoWindow(house);

                        if (this.activePopup) {
                            this.activePopup.setMap(null);
                        }

                        this.activePopup = new CustomPopupOverlay(this.markers[house.id].position, content, this.map);

                        const closeBtn = content.querySelector('.close');
                        if (closeBtn) {
                            closeBtn.addEventListener('click', (e) => {
                                e.stopPropagation(); // evita chiusure involontarie
                                this.activePopup.setMap(null);
                                this.activePopup = null;
                            });
                        }
                    });
                } catch (advError) {
                    console.warn("Non è stato possibile creare il marker avanzato:", advError);
                }
            }
        });
        this.clusters = new MarkerClusterer({
            map: Alpine.raw(this.map),
            markers: Object.values(this.markers),
            renderer: {
                render: ({count, position}) => {
                    const clusterElement = document.createElement('div');
                    clusterElement.className = 'custom-cluster';
                    clusterElement.textContent = count;
                    return new AdvancedMarkerElement({
                        position,
                        content: clusterElement,
                        zIndex: 1000,
                    });
                },
            },
        });
    },
    centerMapOnMarkers() {
        if (this.validCoordinates.length === 0) {
            return;
        }

        if (this.validCoordinates.length === 1) {
            const rawMap = Alpine.raw(this.map);
            rawMap.setCenter(this.validCoordinates[0]);
            rawMap.setZoom(14);
            return;
        }

        const bounds = new google.maps.LatLngBounds();

        this.validCoordinates.forEach(coord => {
            bounds.extend(new google.maps.LatLng(coord.lat, coord.lng));
        });

        const rawMap = Alpine.raw(this.map);
        rawMap.fitBounds(bounds);

        rawMap.fitBounds(bounds, {
            top: 50,
            right: 50,
            bottom: 50,
            left: 50
        });

        google.maps.event.addListenerOnce(rawMap, 'bounds_changed', () => {
            if (rawMap.getZoom() > 16) {
                rawMap.setZoom(16);
            }
        });
    },
    highlightMarker(houseId) {
        Object.values(this.markerElements).forEach(markerElement => markerElement.lower());

        if (this.markerElements[houseId]) {
            this.markerElements[houseId].elevate();
        }
    },
    addHouseHoverListener() {
        document.addEventListener('DOMContentLoaded', () => {
            const houseElements = document.querySelectorAll('[data-house-id]');

            houseElements.forEach(element => {
                const houseId = element.getAttribute('data-house-id');
                element.addEventListener('mouseenter', () => {
                    this.highlightMarker(houseId);
                });

                element.addEventListener('mouseleave', () => {
                    Object.values(this.markerElements).forEach(markerElement => {
                        markerElement.lower();
                    });
                });
            });
        });
    },

    getInfoWindow(house) {
        return `
            <div class="info__window__content">
                <div class="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                    </svg>
                </div>
                <a href="${house.permalink}" target="_blank">
                    <div class="image">
                        <img src="${house.imageUrl}" alt="${house.title}">
                    </div>
                    <div class="content__text">
                        <div class="first__row">
                            <h3>${house.title}</h3>
                            <div class="average__rating">${house.rating}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                              <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
                            </svg>

                            </div>
                        </div>
                        <div class="tourist__area__text">${house.touristArea}</div>
                        <p class="price">${house.price} € ${house.priceLabel}</p>
                    </div>
                </a>
            </div>
        `;
    }

});